import { Component, inject, input } from "@angular/core";
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "files/auth/auth.service";
import { Subject } from "rxjs";

import { TranslateModule } from "@ngx-translate/core";
import { TrimDirective } from "common/trim.directive";
import { SpinComponent } from "common/spin/spin.component";

export type AuthResult = "cancel" | "ok";

@Component({
	selector: "stages-files-auth-embeddable",
	templateUrl: "./files-auth-shared-template.html",
	imports: [ReactiveFormsModule, TranslateModule, TrimDirective, SpinComponent],
})
export class FilesAuthEmbeddableComponent {
	private route = inject(ActivatedRoute);
	private authService = inject(AuthService);

	readonly cmsTypeMessageKey = input.required<string>();

	form: UntypedFormGroup;

	showHeader = false;
	loading = false;
	authRetryFailed = false;

	resultSubject = new Subject<AuthResult>();

	readonly keys = input<{
		fileId: string | null;
		elementType: string | null;
		elementId: string | null;
		workspaceId: string;
		processVersion: string;
	}>();

	constructor() {
		this.form = new UntypedFormGroup({
			username: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
			password: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
		});
	}

	getCmsTypeMessageKey(): string {
		return this.cmsTypeMessageKey();
	}

	clearLoginError(): void {
		this.authRetryFailed = false;
	}

	cancel(): void {
		this.resultSubject.next("cancel");
	}

	ok(): void {
		const keys = this.keys();
		const keysValue = this.keys();
		const keysVal = this.keys();
		const keysInput = this.keys();
		const keys_1 = this.keys();
		this.authService
			.authenticate(
				this.form.get("username")!.value,
				this.form.get("password")!.value,
				(keys && keys.fileId) || this.route.snapshot.paramMap.get("fileId"),
				(keysValue && keysValue.elementType) || this.route.snapshot.paramMap.get("elementType")!,
				(keysVal && keysVal.elementId) || this.route.snapshot.paramMap.get("elementId")!,
				(keysInput && keysInput.workspaceId) || this.route.snapshot.paramMap.get("workspaceId")!,
				(keys_1 && keys_1.processVersion) || this.route.snapshot.paramMap.get("processVersion")!,
			)
			.then(
				() => {
					this.resultSubject.next("ok");
				},
				(errorResponse) => {
					this.loading = false;
					if (errorResponse.status === 901) {
						this.authRetryFailed = true;
					}
				},
			);
	}
}
